import React, { useState, useContext, useEffect, useRef } from 'react';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Badge, Body1Strong, Subtitle2, Title3, Body1, Caption1, Subtitle1, FluentProvider, webLightTheme, Theme, createLightTheme, createDarkTheme, BrandVariants, Input, Image, Card, InfoLabel, ButtonProps, Tooltip, Link, Textarea, ToggleButton } from "@fluentui/react-components";
import { Info20Regular, Open20Regular, GroupList20Regular, TrayItemRemove20Filled, DesktopPulse20Regular, Wrench20Regular, ShieldQuestion20Regular, LockClosedKey20Regular, BookDatabase20Regular, BookTemplate20Regular, ChatMultipleHeart20Regular, Filter20Filled, FilterDismiss20Filled, Desktop20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Settings20Regular, ArrowMaximize20Regular, Dismiss16Regular, DismissSquare24Filled, FilterAdd20Filled, Info20Filled, Delete20Regular, AddSquare20Regular } from "@fluentui/react-icons";
import { fullscreenIcon, lightTheme, messageTheme, primaryIcon, exitIcon, secondaryIcon, overflowDivider, buttonContent, inputFieldCSS, dividerWidthStyle, SubSectionResponsive, DynamicBoxingCSS, parentHome, wraperStyle, dashboardTheme, BreadcrumbsBorder } from "../../../styles/customStyles";
import { DatePicker, DefaultButton, PrimaryButton, Stack, StackItem, TooltipHost } from "@fluentui/react";
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import { Breadcrumbs } from '../../../components/breadcrumbs/breadcrumbs.component';
import { SideMenu } from '../../../components/side_menu/inline_side_menu.component';
import { OverflowSetCustomExample } from '../../../components/side_menu/overFlowSet.component';
import { SearchBar } from '../../../components/searchbar/searchbar.component';
import { MenuDropdown } from '../../../components/dropdown/menu.component';
import { DropdownComponent } from '../../../components/dropdown/dropdown.component';
import { Pagination } from '../../../components/pagination/pagination.component';
import { ToastComponent } from '../../../components/toast/toast.component';
import { SkeletonDataTable } from '../../../components/skeleton/skeletonDataTable';
import OverLay from '../../../components/side_menu/overlay_side_menu.component';
import FullScreenButton from '../../../components/fullscreen/fullScreen.component';
import { usePermissionStore } from "../../../Store/permissionStore";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from '../../../hooks/globalContext';
import { DatepickerComponent } from '../../../components/picker/datepicker.component';
import { DataTable } from "../../../components/data_table/data_table.component";
import DialogBox from '../../../components/dialog/dialog.component';
import { InfoBar } from '../../../components/infoBar/infoBar.component';
import { CSVLink } from 'react-csv';
import { DynamicDialog } from '../../../components/dialog/dynamic.dialog.component';
import { CensusData, CheckboxState } from "../../../interfaces/devices/census_interface";
import { DateComponent } from '../dateComponent';
import { Asset_event_func } from './asset_event_func';
import { Form } from '@rjsf/fluent-ui';
import validator from '@rjsf/validator-ajv8';
import { CustomWidgets } from '../../../components/form-components';

const SubAssets = () => {
    const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
    const [overlayOpen, setOverlayOpen] = useState(false);
    const [isOverlayFilter, setIsOverlayFilter] = useState(false);
    const [isfilter, setIsFilter] = useState(false);
    const [isResetDisabled, setResetDisabled] = useState(true);
    const [refreshToast, setRefreshToast]: any = useState(false);
    const [errorToast, setErrorToast] = useState(false);
    const [isToast, setIsToast] = useState(false);
    const [final_data, set_final_data]: any = useState<CensusData[] | null>(null);
    const [filterArray, setFilterArray] = useState<string[]>([]);
    const [searchVal, setSearchVal] = useState("");
    const [overLayData, setOverLayData] = useState<any>({});
    const [totalPages, setTotalPages] = useState<number>(1);
    const [currentPageNo, setCurrentPageNo] = useState<number>(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [filterMenuOpen, setFilterMenuOpen] = useState(false);
    const [selectedTableData, setSelectedTableData] = useState([]);
    const [filterMenuOpenOverlay, setFilterMenuOpenOverlay] = useState(false);
    const [exportBtnClicked, setExportBtnClicked] = useState(false);
    const [isRefresh, setIsRefresh]: any = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [filterColumnsData, setFilterColumnsData] = useState([]);
    const [dropDownValue1, setDropDownValue1] = useState<any>();
    const [dropDownValue2, setDropDownValue2] = useState<any>();
    const [exportData, setExportData]: any = useState([]);
    const [dropDownValue1Overlay, setDropDownValue1Overlay] = useState<any>();
    const [dropDownValue2Overlay, setDropDownValue2Overlay] = useState<any>();
    const [loading, setLoading] = useState(true);
    const [isOsName, setOsName] = useState([]);
    const contextValue: any = useContext(GlobalContext);
    const [overlayName, setOverlayName] = useState('');
    const [isLatest, setIsLatest] = useState<boolean>(true);
    const formRef = useRef(null);
    // EXPORT FUNCTIONALITY
    const [exportOpen, setExportOpen] = useState('');
    const handle = useFullScreenHandle();
    const { permissions } = usePermissionStore();
    const navigate = useNavigate();
    var tenantName = contextValue.tenantName;
    var menuItems: any = [];

    useEffect(() => {
        if (filterArray.length > 0) { setResetDisabled(false) }
    }, [filterArray])
    var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    // NOTE THAT THIS IS A HARDCODED DATA, NOT AN ACTUAL DATA FROM DATABASE, HAVE TO MAKE IT DYNAMIC

    const [exportDetails, setExportDetails]: any = useState([]);
    const [saveBtnClicked, setSaveBtnClicked]: any = useState(false);
    const [editBtnClicked, setEditBtnClicked]: any = useState(false);
    const [jsonData, setJsonData]: any = useState({});
    const [uiData, setUiData] = useState({});
    const [formDataAlert, setFormDataAlert]: any = useState({});
    const [toastAlertCreate, setToastAlertCreate] = useState(false)
    const [toastAlertEdit, setToastAlertEdit] = useState(false)
    const [toastAlertDelete, setToastAlertDelete] = useState(false)
    const [toastAlertError, setToastAlertError] = useState(false)
    const [rowID, setRowID]: any = useState(null);
    const [readOnly, setReadOnly] = useState<boolean>(false);
    const [deleteAlert, setIsDeleteAlert] = useState(false);
    const [importedDataInserted, setImportedDataInserted] = useState<any>(false);
    const [selectedAsset, setSelectedAsset]: any = useState();
    const [singleAsset, setSingleAsset] = useState([]);
    const [singleTableData, setSingleTableData]: any = useState([]);
    const [formData, setFormData]: any = useState({
        name: '',
        description: ''
    });
    const [troubleshooterList, setTroubleshooterList] = useState([])
    const [selectedTroubleshooterList, setSelectedTroubleshooterList] = useState([]);

    // REACT JSON FORM RENDERING
    const handleNewFormChange = (e: any) => {
        setFormData({
            ...formData,
            jsonData: e.formData
        });
    }

    const inputChange = (e: any) => {
        const enteredValue = e.target.value;
        let name = e.target.name;
        const regexS = /^[A-Za-z ]*$/;
        const regexSN = /^[A-Za-z0-9_ ]*$/;
        const regexN = /^[0-9]*$/;
        if (name === 'filter' && dropDownValue1 === ("Device Name")) {
            if (regexSN.test(enteredValue)) {
                setDropDownValue2(enteredValue);
            }
        }
        if (name === 'filter' && dropDownValue1 === ("Nanoheal Version")) {
            if (regexN.test(enteredValue)) {
                setDropDownValue2(enteredValue);
            }
        }
        if (name === 'filter' && dropDownValue1 === ("Manufacturer")) {
            if (regexS.test(enteredValue)) {
                setDropDownValue2(enteredValue);
            }
        }
    }

    const handleFilterArray = (): any => {
        const value1 = dropDownValue1
        const value2 = dropDownValue2;
        const result = value1 + " : " + value2;
        setFilterArray([...filterArray, result])
        setIsFilter(true);
        setLoading(true);
        setDropDownValue1('');
        setDropDownValue2('');
    }

    const handleCloseFilter = (index: any): any => {
        const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
        setFilterArray(updatedArray);
        !isOverlayFilter && setLoading(true);

        setIsOverlayFilter(false);
    }

    const handleOnCLickEdit = (val: any) => {
        setLoading(true);
        setRowID(val.id);
        setSelectedAsset(val.query);
        contextValue.setSelectedAssetRow(val.query);
        navigate('results');
    }

    var menuLists: any = [];
    var tempSingleTableData: any = [];

    useEffect(() => {
        // Data table values append code starts here
        console.log("singleTableData=", singleTableData);

        singleTableData?.rows !== undefined && singleTableData.rows !== null
            ? singleTableData?.rows.length > 0 && singleTableData?.rows.map((val: any, index: any) => {
                const rowData = {};
                singleTableData?.dataSchema?.columnNames?.forEach((key: any, index: any) => {
                    rowData[key] = { label: <Caption1 >{val[index] === "null" ? "--" : val[index]}</Caption1> };
                });

                {
                    permissions.includes("all") || permissions.includes("alert_Fullaccess") ?
                        tempSingleTableData.push({
                            ...rowData,
                            checkbox: 'hide'
                        })
                        :
                        tempSingleTableData.push({
                            machine: val.id,
                            siteName: val.status === 'Attached' ? 'hide' : 'show',
                            v_memorysize: { label: <Button shape="circular" style={buttonContent} onClick={(e: any) => { handleOnCLickEdit(val) }} appearance="transparent" size="small"> {val.name} </Button> },
                            T: { label: <Caption1 >{val.createdBy}</Caption1> }
                        })
                }
            }) : (tempSingleTableData = []);

        tempSingleTableData.length > 0 ? setSingleAsset(tempSingleTableData) : setSingleAsset([]);

        setTimeout(() => {
            singleTableData?.rows !== undefined && singleTableData?.rows !== null && setLoading(false);
        }, 500);
    }, [singleTableData, permissions, formData]);

    useEffect(() => {
        exportData.length > 0 && document.getElementById('csv-export-link')?.click();
    }, [exportData]);

    // overflow set contents code starts here
    var overFlowComponent = {
        data:
            <>
                <StackItem>
                    <Button shape="circular"
                        size="small"
                        appearance="subtle"
                        disabled={loading}
                        onClick={() => {
                            setCurrentPageNo(1);
                            setIsRefresh(true);
                            setLoading(true);
                        }}
                    >
                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                            <StackItem> {loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />} </StackItem>
                            <StackItem> <Caption1> Refresh </Caption1> </StackItem>
                        </Stack>
                    </Button>

                    {permissions.includes("all") || permissions.includes("deviceClassification_Fullaccess") || permissions.includes("deviceClassification_ReadandExport") ?
                        <>
                            <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_DeviceClassifications.csv`} >
                            </CSVLink>
                            <Button shape="circular" disabled={loading} size="small" appearance="subtle"
                                onClick={() => { setExportBtnClicked(true); }}  >
                                <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <StackItem>{loading ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                                    <StackItem> <Caption1> Export </Caption1> </StackItem>
                                </Stack>
                            </Button>
                        </>
                        :
                        <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                            <Button shape="circular" appearance="subtle" size="small" disabled>
                                <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <StackItem><Text></Text></StackItem>
                                    <StackItem>
                                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                                            <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                                            <StackItem><Caption1> Export </Caption1></StackItem>
                                        </Stack>
                                    </StackItem>
                                </Stack>
                            </Button>
                        </Tooltip>
                    }
                </StackItem>
            </>
        ,
    };

    const generateQueries = (data: any) => {
        const createCondition = (condition: any) => {
            const field = condition["Select the asset from the dropdown"];
            const operator = condition.lastCondition.ConditionType;
            const renderOperator = operator === 'like start%' ? 'like' : operator === 'like %end' ? 'like' : operator;
            const conditionValues = condition.lastCondition.ConditionValue
            const value = operator === 'like' ? `%${conditionValues}%` :
                operator === 'not like' ? `%%${conditionValues}` :
                    operator === 'like start%' ? `${conditionValues}%` :
                        operator === 'like %end' ? `%${conditionValues}` :
                            conditionValues;
            const addOperator = condition.lastCondition?.Add === undefined ? '' : condition.lastCondition?.Add;
            // Base condition
            let query = `(${field} ${renderOperator} '${value}') ${addOperator}`;

            // Traverse `nextCondition` if it exists
            let next = condition.lastCondition.nextCondition;
            while (next) {
                const nextOperator = next.ConditionType;
                const nextRenderOperator = nextOperator === 'like start%' ? 'like' : nextOperator === 'like %end' ? 'like' : nextOperator;
                const nextconditionValues = next.ConditionValue
                const nextValue = nextOperator === 'like' ? `%${nextconditionValues}%` :
                    nextOperator === 'not like' ? `%%${nextconditionValues}` :
                        nextOperator === 'like start%' ? `${nextconditionValues}%` :
                            nextOperator === 'like %end' ? `%${nextconditionValues}` :
                                nextconditionValues;
                const add = next.Add === undefined ? '' : ` ${next.Add}`;
                query += ` (${field} ${nextRenderOperator} '${nextValue}')${add}`;
                next = next.nextCondition;
            }

            return query;
        };

        return data?.conditional?.map((item: any) => {
            const dataName = item["Select Data Name"];
            const conditions = item?.conditionals?.map((cond: any) => createCondition(cond))
                .join(" and ");

            return `(dataid = ${dataName} and (${conditions}))`;
        }).join(" and ");
    };

    const dataschema = singleTableData?.dataSchema?.columnNames
    const tablecolums = dataschema?.map((data: any) => ({ key: data, "label": <Body1Strong>{data} </Body1Strong> }))

    useEffect(() => {

        setOverLayData({
            size: "large",
            isTabs: true,
            headerTitle:
                (
                    <>
                        <FluentProvider theme={dashboardTheme}>
                            {overlayName === 'edit' ? <Title3> Edit Asset Query </Title3> : <Title3> Create Asset Query </Title3>}
                        </FluentProvider>
                    </>
                ),
            tabItems: {
                Introduction: <Stack verticalFill tokens={{ childrenGap: '8px' }}>
                    <Stack></Stack>
                    <InfoBar showSpaces={true} title={"These details will make it easy to find the snippets later when you need to use them."} />
                    <Stack verticalFill tokens={{ childrenGap: 20 }} style={dividerWidthStyle}>
                        <Stack verticalFill tokens={{ childrenGap: '8px' }} style={dividerWidthStyle}>
                            <Body1Strong>Asset Query Name</Body1Strong>
                            <Input
                                size="small"
                                style={inputFieldCSS}
                                placeholder='Installed software list'
                                onChange={(e) => setFormData((prev: any) => ({ ...prev, name: e.target.value }))}
                            />
                        </Stack>
                        <Stack verticalFill tokens={{ childrenGap: '8px' }} style={dividerWidthStyle}>
                            <Body1Strong>What is the benfit?</Body1Strong>
                            <Textarea
                                size="small"
                                style={{}}
                                placeholder='Get the list of installed softwares'
                                onChange={(e) => setFormData((prev: any) => ({ ...prev, description: e.target.value }))}
                            />
                        </Stack>
                    </Stack>
                </Stack>
                ,
                "Create Asset Query": <Stack verticalFill tokens={{ childrenGap: '8px' }}>
                    <Stack></Stack>
                    <InfoBar showSpaces={true} title={"Choose the filter criteria to search for assets. Specify the starting date (From Date) for the search. To perform a real-time query, leave the To Date field blank. If no To Date is selected, the query will continuously update with new data as it becomes available."} />
                    <Stack verticalFill tokens={{ childrenGap: 20 }} style={dividerWidthStyle}>
                        <Stack verticalFill tokens={{ childrenGap: '20' }} style={dividerWidthStyle}>
                            <Stack verticalFill tokens={{ childrenGap: '20' }}>
                                {/* <Body1Strong>Query result for</Body1Strong> */}
                                <Form key={JSON.stringify(jsonData)} id="SearchForm" ref={formRef} formData={formData.jsonData} schema={jsonData} uiSchema={uiData} validator={validator} widgets={CustomWidgets} onChange={(e) => handleNewFormChange(e)} />
                                {/* <DateComponent setIsLatest={setIsLatest} isLatest={isLatest} /> */}
                            </Stack>
                            {isLatest !== true ? (<Stack horizontal tokens={{ childrenGap: '20' }} style={dividerWidthStyle}>
                                <Stack verticalFill tokens={{ childrenGap: '8' }} style={{ width: '40%' }}>
                                    <Body1Strong>Search result from</Body1Strong>
                                    <Stack >
                                        <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />
                                    </Stack>
                                </Stack>
                                <Stack verticalFill tokens={{ childrenGap: '8' }} style={{ width: '40%' }}>
                                    <Body1Strong>Search result to</Body1Strong>
                                    <Stack >
                                        <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />
                                    </Stack>
                                </Stack>
                            </Stack>) : (<Stack></Stack>)}
                        </Stack>
                    </Stack>
                </Stack>,
                "Review and Create": <Stack verticalFill tokens={{ childrenGap: '8px' }}>
                    <Stack></Stack>
                    <InfoBar showSpaces={true} title={"Choose the filter criteria to search for assets. Specify the starting date (From Date) for the search. To perform a real-time query, leave the To Date field blank. If no To Date is selected, the query will continuously update with new data as it becomes available."} />
                    <Stack verticalFill tokens={{ childrenGap: 20 }} style={dividerWidthStyle}>
                        <Stack verticalFill tokens={{ childrenGap: '20' }} style={dividerWidthStyle}>
                            <Stack verticalFill tokens={{ childrenGap: '20' }}>
                                {/* <Body1Strong>Query result for</Body1Strong> */}
                                <Form key={JSON.stringify(jsonData)} id="SearchForm" disabled formData={formData.jsonData} schema={jsonData} uiSchema={uiData} validator={validator} widgets={CustomWidgets} onChange={(e) => handleNewFormChange(e)} />
                                <DateComponent setIsLatest={setIsLatest} isLatest={isLatest} />
                            </Stack>
                            {isLatest !== true ? (<Stack horizontal tokens={{ childrenGap: '20' }} style={dividerWidthStyle}>
                                <Stack verticalFill tokens={{ childrenGap: '8' }} style={{ width: '40%' }}>
                                    <Body1Strong>Search result from</Body1Strong>
                                    <Stack >
                                        <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />
                                    </Stack>
                                </Stack>
                                <Stack verticalFill tokens={{ childrenGap: '8' }} style={{ width: '40%' }}>
                                    <Body1Strong>Search result to</Body1Strong>
                                    <Stack >
                                        <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />
                                    </Stack>
                                </Stack>
                            </Stack>) : (<Stack></Stack>)}
                        </Stack>
                    </Stack>
                </Stack>,
            }
        });
    }, [selectedTableData, dropDownValue1Overlay, dropDownValue2Overlay, filterMenuOpenOverlay, filterArray, isfilter, isLatest, jsonData, formData]);

    if (permissions.includes("all") || permissions.includes("overview_Read") || permissions.includes("overview_ReadandExport") || permissions.includes("overview_Fullaccess")) {
        menuItems.push
            (
                <FluentProvider theme={lightTheme}>
                    <MenuItem key={0} onClick={() => navigate("/manage/search/asset")}
                        icon={
                            <Stack horizontal tokens={{ childrenGap: 40 }}>
                                <StackItem><Text></Text></StackItem>
                                <StackItem> <Info20Regular {...primaryIcon} /> </StackItem>
                            </Stack>}>
                        <Stack tokens={{ childrenGap: 30 }} horizontal>
                            <StackItem><Text></Text></StackItem>
                            <StackItem> <Caption1> Asset </Caption1> </StackItem>
                            <StackItem> <Stack tokens={{ childrenGap: 80 }} horizontal> <StackItem><Text></Text></StackItem> <StackItem><Text></Text></StackItem> </Stack> </StackItem>
                            {/* SPACING IN INLINE SIDEBAR */}
                        </Stack>
                    </MenuItem>
                </FluentProvider>
            )
    }

    if (permissions.includes("all") || permissions.includes("deviceClassification_Read") || permissions.includes("deviceClassification_ReadandExport") || permissions.includes("deviceClassification_Fullaccess")) {
        menuItems.push
            (
                <MenuItem key={1} onClick={() => navigate("/manage/search/event")}
                    icon={
                        <Stack horizontal tokens={{ childrenGap: 40 }}>
                            <StackItem><Text></Text></StackItem>
                            <StackItem> <GroupList20Regular {...primaryIcon} /> </StackItem>
                        </Stack>}>
                    <Stack tokens={{ childrenGap: 30 }} horizontal>
                        <StackItem><Text></Text></StackItem>
                        <StackItem> <Caption1> Event </Caption1> </StackItem>
                    </Stack>
                </MenuItem>
            );
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const query = contextValue.selectedAssetRow;
                const apiUrl = 'https://pinot-nh.unifie.io/sql';

                console.log("query=", query);

                const requestBody = {
                    sql: query,
                    "trace": false,
                    "queryOptions": "useMultistageEngine=true"
                };
                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(requestBody),
                });

                const responseData = await response.json();
                if (responseData) {
                    var assetData = responseData.resultTable
                    setSingleTableData(assetData);
                }
            } catch (error) {
                console.error("An unexpected error occurred=", (error as Error).message);
            }
        }

        fetchData();
    }, [searchVal, currentPageNo, isRefresh]);

    return (
        <>
            <FullScreen handle={handle} className="fullScreenBackgroundColor">
                <StackItem grow shrink style={BreadcrumbsBorder}>
                    <Stack tokens={{ childrenGap: 10 }} horizontal>
                        <StackItem grow shrink>
                        <Stack tokens={{childrenGap:5}} horizontalAlign="start">
                            <StackItem><Text></Text></StackItem>
                            <StackItem grow shrink>
                            <Breadcrumbs
                                items={[
                                {name: "Manage", link: "/home" },
                                {name:"Search", link:"/manage/search/asset"},
                                {name:"Asset", link:"/manage/search/asset"},
                                {name:"Results", link:"#"},
                                ]} 
                            /> 
                            </StackItem>
                        </Stack>
                        </StackItem>
                    </Stack>
                </StackItem>

                <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
                    <StackItem style={DynamicBoxingCSS}>
                        {/* pages code starts here */}
                        <Stack style={DynamicBoxingCSS}>

                            <Stack tokens={{ childrenGap: 25 }} horizontal>
                                <StackItem> <Text></Text> </StackItem>
                                <StackItem>
                                    <FluentProvider theme={dashboardTheme}>
                                        <Title3> Asset | Results </Title3>
                                    </FluentProvider>
                                </StackItem>
                            </Stack>
                            <FluentProvider style={parentHome} theme={dashboardTheme}>
                                <Stack style={parentHome} horizontal>
                                    {/* SPACING BETWEEN INLINE AND PAGE */}
                                    <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={menuItems} />
                                    <StackItem style={DynamicBoxingCSS}>
                                        <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                                            <StackItem>
                                                <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                                                {singleAsset.length > 0 ? <Divider /> : <Divider style={overflowDivider} />}
                                            </StackItem>
                                            <StackItem style={wraperStyle}>
                                                <StackItem>
                                                    <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                                                        <Stack horizontal tokens={{ childrenGap: 10 }}>
                                                            <StackItem>
                                                            <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={""} searchVal={searchVal} setSearchVal={setSearchVal} disabled={loading || singleAsset.length === 0} />
                                                            </StackItem>
                                                            <StackItem>
                                                                <MenuDropdown open={filterMenuOpen} btn={
                                                                    <MenuButton disabled={loading || singleAsset.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                                                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                            <FilterAdd20Filled {...primaryIcon} />
                                                                            <Body1> Filter </Body1>
                                                                        </Stack>
                                                                    </MenuButton>
                                                                } itemVal={<><Body1Strong> Add a Filter </Body1Strong>
                                                                    <Divider />
                                                                    <MenuList>
                                                                        <Stack tokens={{ childrenGap: 5 }}>
                                                                            <StackItem> <Text></Text> </StackItem>
                                                                            <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                                                            {/* <DropdownComponent optionData={columns1} setDropDownValue = {setDropDownValue1} dropDownvalue = {dropDownValue1} /> */}
                                                                            <DropdownComponent optionData={filterColumnsData} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
                                                                            <StackItem> <Divider /> </StackItem>
                                                                            <StackItem> <Caption1> Value </Caption1> </StackItem>
                                                                            {(dropDownValue1 === 'Installation Date' || dropDownValue1 === 'Last Check-in in 1 Week' || dropDownValue1 === 'Last Check-in in 24 Hours') && <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />}
                                                                            {dropDownValue1 === "Operating System" && <DropdownComponent optionData={isOsName} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />}
                                                                            {(dropDownValue1 === "Device Name" || dropDownValue1 === "Manufacturer" || dropDownValue1 === "Nanoheal Version") && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                                                            <StackItem> <Divider /> </StackItem>
                                                                            <Stack tokens={{ childrenGap: 10 }} horizontal>
                                                                                <StackItem>
                                                                                    <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
                                                                                        disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`))}>
                                                                                        <Caption1> Apply </Caption1>
                                                                                    </Button>
                                                                                </StackItem>

                                                                                <StackItem>
                                                                                    <Button shape="circular" onClick={() => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); }}>
                                                                                        <Caption1> Cancel </Caption1>
                                                                                    </Button>
                                                                                </StackItem>
                                                                            </Stack>
                                                                        </Stack>
                                                                    </MenuList>
                                                                </>} />
                                                            </StackItem>
                                                            <StackItem onClick={() => { setIsOverlayFilter(false); setFilterArray([]); setIsFilter(false); setDropDownValue2Overlay(''); setResetDisabled(true); }}>
                                                                <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                        <StackItem> <FilterDismiss20Filled /> </StackItem>
                                                                        <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                                                    </Stack>
                                                                </Button>
                                                            </StackItem>
                                                        </Stack>
                                                        {(singleAsset.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                                                    </Stack>
                                                    {filterArray.length > 0 && <Stack tokens={{ padding: '10px 0px 0px 0px' }}>
                                                        <Stack wrap horizontal >
                                                            {filterArray.length > 0 && filterArray.map((item, index) => (
                                                                <Button shape="circular" size="small">
                                                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                        <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                                                        <StackItem>
                                                                            <Stack tokens={{ childrenGap: 1 }}>
                                                                                <StackItem><Text></Text></StackItem>
                                                                                <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                                                            </Stack>
                                                                        </StackItem>
                                                                    </Stack>
                                                                </Button>
                                                            ))}
                                                        </Stack>
                                                    </Stack>}
                                                </StackItem>
                                                <InfoBar showSpaces={true} title={"Explore our troubleshooting snippets for a smooth start. Pick a setup scenario, and we'll guide you through each step, handling assignments and other configurations automatically."} />
                                                {singleAsset.length > 0 && <Stack horizontal enableScopedSelectors horizontalAlign="space-between">
                                                    <StackItem> {totalRecords > 0 && <Caption1> Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records </Caption1>} </StackItem>
                                                </Stack>}
                                            </StackItem>

                                            {refreshToast && <ToastComponent setmessagebar={setRefreshToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}

                                            {isToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={toastMessage} footer="" />}

                                            {errorToast && (<ToastComponent setmessagebar={setErrorToast} toastIntent="error" position="top-end" title="Failed" message={toastMessage} footer="" />)}

                                            {loading ? (<SkeletonDataTable />) : (singleAsset?.length > 0 ?
                                                (<DataTable tableData={singleAsset} columns={tablecolums} />) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>)}
                                        </Stack>
                                    </StackItem>
                                </Stack>
                            </FluentProvider>
                        </Stack>
                        <OverLay overlayopen={overlayOpen} setOverlayOpen={setOverlayOpen} saveBtnFunc={setSaveBtnClicked} overlayData={overLayData} isNavBtn={true} />
                    </StackItem>
                    <StackItem><Text></Text></StackItem>
                </Stack>
            </FullScreen>
        </>
    )
}

export default SubAssets;